import { OrbiObjectType } from "./orbiobjecttype";
export var OrbiAuditResultImpact;
(function (OrbiAuditResultImpact) {
    OrbiAuditResultImpact["_EnumKey"] = "RFMF";
    OrbiAuditResultImpact["NoImpact"] = "TLDR.NoImp";
    OrbiAuditResultImpact["TLDRInformative"] = "TLDR.Inf";
    OrbiAuditResultImpact["TLDRIntegrity"] = "TLDR.Int";
    OrbiAuditResultImpact["TLDRConfidentiality"] = "TLDR.Cnf";
    OrbiAuditResultImpact["TLDRAvailability"] = "TLDR.Avl";
    OrbiAuditResultImpact["TLDRMarketplace"] = "TLDR.Mkt";
    OrbiAuditResultImpact["CtrlAccessControl"] = "Ctrl.Ac";
    OrbiAuditResultImpact["CtrlAuthorization"] = "Ctrl.Az";
    OrbiAuditResultImpact["CtrlChangeControl"] = "Ctrl.Chng";
    OrbiAuditResultImpact["CtrlIntegrity"] = "Ctrl.Intrgty";
    OrbiAuditResultImpact["CtrlPostureMgmt"] = "Ctrl.PstMgmt";
    OrbiAuditResultImpact["DomainPublicInformationLeaks"] = "Dmn.lks";
    OrbiAuditResultImpact["DomainContinuousDeployment"] = "Dmn.Cd";
    OrbiAuditResultImpact["DomainContinuousIntegration"] = "Dmn.Ci";
})(OrbiAuditResultImpact || (OrbiAuditResultImpact = {}));
;
export var OrbiAuditResultRelevance;
(function (OrbiAuditResultRelevance) {
    OrbiAuditResultRelevance["_EnumKey"] = "RARL";
    OrbiAuditResultRelevance["Relevant"] = "TLDR.yes";
    OrbiAuditResultRelevance["NotRelevant"] = "TLDR.no";
    OrbiAuditResultRelevance["AffectsOrgAcc"] = "TLDR.OrgAcc";
    OrbiAuditResultRelevance["AffectsProd"] = "TLDR.Prd";
    OrbiAuditResultRelevance["CiCd"] = "repo.cicd";
    OrbiAuditResultRelevance["ProdRepo"] = "repo.prd";
    OrbiAuditResultRelevance["ProdBranch"] = "repo.brn.prd";
    OrbiAuditResultRelevance["PublicRepo"] = "repo.pub";
    OrbiAuditResultRelevance["PR_MergedToPrdBrn"] = "pr.mgdprdbrn";
    OrbiAuditResultRelevance["PR_ChangeIsSignificant"] = "pr.chngsig";
})(OrbiAuditResultRelevance || (OrbiAuditResultRelevance = {}));
export var OrbiAuditResultTest;
(function (OrbiAuditResultTest) {
    OrbiAuditResultTest["_EnumKey"] = "RATS";
    OrbiAuditResultTest["SomeTest"] = "SmeTst";
    OrbiAuditResultTest["AlwaysFinding"] = "AllFnd";
    OrbiAuditResultTest["DataAcquisitionOk"] = "DataOk";
    OrbiAuditResultTest["Permission_ACLHasDirectUser"] = "Per.NoUser";
    OrbiAuditResultTest["Permission_ACLHasDirectUserWhoIsNotAdmin"] = "Per.NoUserNotAdmin";
    OrbiAuditResultTest["Org_Githubappauthz"] = "org.appauthz";
    OrbiAuditResultTest["Org_Githubappconfig"] = "org.appcfg";
    OrbiAuditResultTest["Org_Mktpurchase"] = "org.mktpur";
    OrbiAuditResultTest["Org_Action"] = "org.action";
    OrbiAuditResultTest["Repo_TooManyPrdBranches"] = "repo.toomnybrn";
    OrbiAuditResultTest["Repo_BranchNameConvention"] = "repo.brnnames";
    OrbiAuditResultTest["Repo_PrdRepoWithNoPrdBranches"] = "repo.noprdbrns";
    OrbiAuditResultTest["Repo_Dk_AllKeysRecent"] = "repo.dknew";
    OrbiAuditResultTest["Repo_Dk_AllDeployKeysReadOnly"] = "repo.dkro";
    OrbiAuditResultTest["Repo_Dk_Exists"] = "repo.dkexists";
    OrbiAuditResultTest["Repo_Bp_Effective"] = "repo.bp";
    OrbiAuditResultTest["Repo_Bp_DefaultBranch_Effective"] = "repo.bp.def";
    OrbiAuditResultTest["Repo_Bp_ApprovingReviewCount"] = "repo.bp.aprrevcnt";
    OrbiAuditResultTest["Repo_Bp_DismissStaleReviews"] = "repo.bp.disstlreviews";
    OrbiAuditResultTest["Repo_Bp_CodeownerReview"] = "repo.bp.corev";
    OrbiAuditResultTest["Repo_Bp_IgnoreApprovalsFromContributers"] = "repo.bp.ignrevcntrs";
    OrbiAuditResultTest["Repo_Bp_AdminEnforced"] = "repo.bp.admenf";
    OrbiAuditResultTest["Repo_Bp_RequireConversationResolution"] = "repo.bp.convres";
    OrbiAuditResultTest["Repo_Bp_ForcePush"] = "repo.bp.frcpsh";
    OrbiAuditResultTest["Repo_Bp_RequireSignedCommits"] = "repo.bp.sgncmt";
    OrbiAuditResultTest["Repo_Bp_Defaultbranchnobp"] = "repo.bp.defno";
    OrbiAuditResultTest["Repo_Bp_None"] = "repo.bp.none";
    OrbiAuditResultTest["Repo_Bp_LiveBranch_Effective"] = "repo.bp.live";
    OrbiAuditResultTest["Repo_Bp_NoBpOnNonPrdBranches"] = "repo.bp.livenon";
    OrbiAuditResultTest["Repo_Bp_AmbiguousBranchProtection"] = "repo.bp.ambig";
    OrbiAuditResultTest["Repo_Bp_PatternWithWildcard"] = "repo.bp.wild";
    OrbiAuditResultTest["Repo_Action"] = "repo.act";
    OrbiAuditResultTest["Repo_Member"] = "repo.mbr";
    OrbiAuditResultTest["Repo_Branch_Creation"] = "repo.brn.cre";
    OrbiAuditResultTest["Repo_Branch_Deletion"] = "repo.brn.del";
    OrbiAuditResultTest["Repo_Branch_DeletionWoMerge"] = "repo.brn.delwomrg";
    OrbiAuditResultTest["Repo_Fork_Exists"] = "repo.fork.exists";
    OrbiAuditResultTest["Repo_HasSecretScanning"] = "repo.wkf.secs";
    OrbiAuditResultTest["Repo_HasStaticAnalysis"] = "repo.wkf.sast";
    OrbiAuditResultTest["Repo_HasCodeOwners"] = "repo.codeowners";
    OrbiAuditResultTest["RepoEnv_hasDeploymentBranchPolicy"] = "repo.env.depbrn";
    OrbiAuditResultTest["RepoEnv_hasSecrets"] = "repo.env.secs";
    OrbiAuditResultTest["PR_AuthorAssoc"] = "pr.autass";
    OrbiAuditResultTest["PR_Review_IsApproved"] = "pr.approve";
    OrbiAuditResultTest["PR_Review_SodSubmitterApprover"] = "pr.sod";
    OrbiAuditResultTest["PR_Review_RequestedIndendent"] = "pr.reqrev";
    OrbiAuditResultTest["PR_Review_hasComments"] = "pr.hasRevCom";
    OrbiAuditResultTest["Commit_hasAssociatedPr"] = "cm.pr";
    OrbiAuditResultTest["Commit_forcedPush"] = "cm.frc";
    OrbiAuditResultTest["Commit_mergeWithoutPr"] = "cm.mrgWoPr";
    OrbiAuditResultTest["Release_Generic"] = "rel.gen";
    OrbiAuditResultTest["Workflow_Generic"] = "wkf.gen";
    OrbiAuditResultTest["Workflowrun_Generic"] = "wkfrun.gen";
    OrbiAuditResultTest["Team_Mod"] = "team.mod";
    OrbiAuditResultTest["Team_Authz"] = "team.authz";
    OrbiAuditResultTest["Team_Generic"] = "team.gen";
    OrbiAuditResultTest["Team_Member"] = "team.mbr";
    OrbiAuditResultTest["Deployment_Generic"] = "dep.gen";
    OrbiAuditResultTest["Secrets_IsEnvSecret"] = "sec.env";
    OrbiAuditResultTest["Secrets_IsRotated"] = "sec.rot";
    OrbiAuditResultTest["User_Ok"] = "usr.ok";
    OrbiAuditResultTest["User_HasName"] = "usr.ok.nm";
    OrbiAuditResultTest["User_HasCompany"] = "usr.ok.co";
    OrbiAuditResultTest["User_HasEmail"] = "usr.ok.eml";
    OrbiAuditResultTest["User_hasPublicKeysSsh"] = "usr.ok.keyssg";
    OrbiAuditResultTest["User_hasPublicKeysSshRotated"] = "usr.ok.keysshrot";
    OrbiAuditResultTest["User_hasPublicKeysGpg"] = "usr.ok.keygpg";
    OrbiAuditResultTest["User_hasPublicKeysGpgRotated"] = "usr.ok.keygpgrot";
    OrbiAuditResultTest["User_hasPublicKeysSgn"] = "usr.ok.keysgn";
    OrbiAuditResultTest["User_hasPublicKeysSgnRotated"] = "usr.ok.keysgnrot";
})(OrbiAuditResultTest || (OrbiAuditResultTest = {}));
;
export var OrbiAuditResultExplain;
(function (OrbiAuditResultExplain) {
    OrbiAuditResultExplain["_EnumKey"] = "RATE";
    OrbiAuditResultExplain["GHAPP_Authzd"] = "GHAPP_AUTHZD";
    OrbiAuditResultExplain["BP_ApprovingReviewCount"] = "BP.AppRev";
    OrbiAuditResultExplain["BP_DismissStaleReviews"] = "BP.DisStlRev";
    OrbiAuditResultExplain["BP_CodeOwnerReview"] = "BP.CoRev";
    OrbiAuditResultExplain["BP_IgnoreContributerReviews"] = "BP.IgnrCntrRev";
    OrbiAuditResultExplain["BP_AdminEnforced"] = "BP.AdmEnf";
    OrbiAuditResultExplain["BP_ReqConvRes"] = "BP.ReqCnvRes";
    OrbiAuditResultExplain["BP_AllowForcePush"] = "BP.AllFp";
    OrbiAuditResultExplain["BP_ReqCommitSigs"] = "BP.ReqCmtSig";
})(OrbiAuditResultExplain || (OrbiAuditResultExplain = {}));
;
export const OrbiAuditResultTestGrouping = {
    [OrbiObjectType.Global]: [OrbiAuditResultTest.DataAcquisitionOk],
    [OrbiObjectType.GithubWebhookCallback]: [],
    [OrbiObjectType.GithubCommitsForRepo]: [
        OrbiAuditResultTest.Commit_hasAssociatedPr,
    ],
    [OrbiObjectType.GithubRepoAccessControl]: [OrbiAuditResultTest.Permission_ACLHasDirectUser, OrbiAuditResultTest.Permission_ACLHasDirectUserWhoIsNotAdmin],
    [OrbiObjectType.GithubPrsForRepo]: [
        OrbiAuditResultTest.PR_Review_IsApproved,
        OrbiAuditResultTest.PR_Review_SodSubmitterApprover,
    ],
    [OrbiObjectType.GithubReleaseForRepo]: [],
    [OrbiObjectType.GithubRepo]: [
        OrbiAuditResultTest.Repo_TooManyPrdBranches,
        OrbiAuditResultTest.Repo_BranchNameConvention,
        OrbiAuditResultTest.Repo_PrdRepoWithNoPrdBranches,
        OrbiAuditResultTest.Repo_Dk_AllKeysRecent,
        OrbiAuditResultTest.Repo_Dk_AllDeployKeysReadOnly,
        OrbiAuditResultTest.Repo_Bp_Effective,
        OrbiAuditResultTest.Repo_Bp_DefaultBranch_Effective,
        OrbiAuditResultTest.Repo_Bp_Defaultbranchnobp,
        OrbiAuditResultTest.Repo_Bp_None,
        OrbiAuditResultTest.Repo_Bp_LiveBranch_Effective,
        OrbiAuditResultTest.Repo_Bp_NoBpOnNonPrdBranches,
        OrbiAuditResultTest.Repo_Bp_AmbiguousBranchProtection,
        OrbiAuditResultTest.Repo_Bp_PatternWithWildcard,
        OrbiAuditResultTest.Repo_HasSecretScanning,
        OrbiAuditResultTest.Repo_HasStaticAnalysis,
        OrbiAuditResultTest.Repo_HasCodeOwners
    ],
    [OrbiObjectType.GithubEnvironment]: [
        OrbiAuditResultTest.RepoEnv_hasDeploymentBranchPolicy,
        OrbiAuditResultTest.RepoEnv_hasSecrets,
    ],
    [OrbiObjectType.GithubRepo + "Public"]: [],
    [OrbiObjectType.GithubSecret]: [OrbiAuditResultTest.Secrets_IsEnvSecret, OrbiAuditResultTest.Secrets_IsRotated],
    [OrbiObjectType.GithubUser]: [OrbiAuditResultTest.User_Ok, OrbiAuditResultTest.User_HasName, OrbiAuditResultTest.User_HasCompany, OrbiAuditResultTest.User_HasEmail,
        OrbiAuditResultTest.User_hasPublicKeysSsh, OrbiAuditResultTest.User_hasPublicKeysSshRotated,
        OrbiAuditResultTest.User_hasPublicKeysGpg, OrbiAuditResultTest.User_hasPublicKeysGpgRotated,
        OrbiAuditResultTest.User_hasPublicKeysSgn, OrbiAuditResultTest.User_hasPublicKeysSgnRotated],
};
export class OrbiAuditResult {
    constructor() {
        this.relevance = {};
        this.impacts = {};
        this.findings = {};
        this.executedtests = {};
        this.explain = {};
    }
}
;
